import { Component, Inject, OnInit } from '@angular/core';
import { MdDialogRef, MdDialog, MD_DIALOG_DATA } from '@angular/material';
import { DestinationTravelPolicy } from 'app/model/products/hotel/hotel.model';

@Component({
  selector: 'act-dialog-share-budget-detail',
  templateUrl: './dialog-share-budget-detail.component.html',
  styleUrls: ['./dialog-share-budget-detail.component.scss']
})
export class DialogShareBudgetDetailComponent implements OnInit {

  constructor(
    private dialogRef: MdDialogRef<DialogShareBudgetDetailComponent>,
    private dialog: MdDialog,
    @Inject(MD_DIALOG_DATA) private shareBudget
  ) { }

  ngOnInit() {
  }

  onClose() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-share-budget/dialog-share-budget-detail/dialog-share-budget-detail.component.ts